namespace Solovis.Reports.Parameters {

    export class ExposureProfileParameterControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public settings;
        public filter;
        public initialParameterValue;
        public currentProfile;

        public selectedProfileLabel;
        public selectProfileLink;

        public _selectionDialog;
        private _exposureProfiles;

        static hasNewRender = true;

        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this.settings = options.settings ? options.settings : {};
            this.filter = this.settings.filter ? this.settings.filter : {};

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : false;
            this.currentProfile = this.initialParameterValue;
        }

        public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices) {
            if (!portalServices) {
                portalServices = new Solovis.Portal.SitePortalServices();
            }

            if (newValue && newValue.id) {
                portalServices.rpc().invoke(
                    "~/Selectors/ExposureProfileSelector/GetProfileData", { id: newValue.id },
                    function (response, success) {
                        if (success) {
                            var profileData = response.result;
                            callback(profileData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else {
                callback(null, true);
            }
        }

        public static serializeParameterValue(value) {
            if (value) {
                if (value.id) {
                    return { id: value.id };
                }
            }

            return null;
        }


        public static getLabel(value): string | undefined {
            return value?.label;
        }

        public doInit() {
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        private doRenderClassic() {
            var self = this;

            this.selectedProfileLabel = $("<span>").appendTo(this.container);
            this.selectProfileLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

            this.selectProfileLink.click(function () {
                self._toggleSelectorDialog(function (profile) {
                    self._setCurrentProfileData(profile);
                    self.notifyParameterValueChanged();
                });
            });

            // Set initial parameter value text.
            if (this.currentProfile) {
                this._setCurrentProfileData(this.currentProfile);
            }
        }

        private async doRenderNew() {
            var self = this;
            const target = this.container[0];
            const { fetchExposureProfiles } = await (window as any).importShim('@solovis/pa-utils');

            await Solovis.UX.Utils.placeComponent(
                "AsyncSelect",
                target,
                {
                    cacheOptions: true,
                    filterOption: (option, input) => {
                        return (ExposureProfileParameterControl.getLabel(option) as string).toLowerCase().indexOf(input.toLowerCase()) > -1
                    },
                    defaultValue: (self.options as any).initialValue || undefined,
                    getOptionLabel: ExposureProfileParameterControl.getLabel,
                    getOptionValue: (option) => option.code,
                    loadOptions: () => new Promise(async (resolve, reject) => {
                        if (self._exposureProfiles) {
                            return resolve(self._exposureProfiles)
                        }

                        try {
                            const options = await fetchExposureProfiles()
                            self._exposureProfiles = options;
                            resolve(options)
                        } catch (e) {
                            reject(e);
                        }
                    }),
                    onChange: (selectedItem) => {
                        this.currentProfile = selectedItem;
                        self.notifyParameterValueChanged();
                    }
                }
            );
        }


        public _setCurrentProfileData(profileData) {
            this.currentProfile = profileData;
            if (this.currentProfile) {
                this.selectedProfileLabel.text(ExposureProfileParameterControl.getLabel(this.currentProfile) + " ");
            }
            else {
                this.selectedProfileLabel.text("");
            }
        }

        public setParameterValue(newValue) {
            this._setCurrentProfileData(newValue);
        }

        public getParameterValue() {
            if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
                return this.initialParameterValue ? this.initialParameterValue : null;
            }
            else if (this.currentProfile) {
                return Solovis.deepCopy(this.currentProfile);
            }
            else {
                return null;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }


        public _toggleSelectorDialog(selectionCallback) {
            var self = this;

            if (this._selectionDialog) {
                // We already have the selection dialog open, so close it.
                this._selectionDialog.close();
                this._selectionDialog = null;
                return;
            }

            var selectorControlHostDiv = $("<div>");
            var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });

            var selectorControl = new Solovis.InvDataSelectors.ExposureProfileSelectorControl({
                controlHost: selectorControlHostDiv,
                portalServices: this._portalServices,
                initialValue: this.currentProfile ? this.currentProfile : null,
                selectionCallback: function (profile) {
                    selectionCallback(profile);
                    self._selectionDialog.close();
                },
                cancelCallback: function () {
                    self._selectionDialog.close();
                }
            });
            selectorControlHost.setCurrentControl(selectorControl);


            // Determine dialog position.        
            var linkOffset = $(this.selectedProfileLabel).offset();
            var linkHeight = $(this.selectProfileLink).outerHeight();
            var dialogPosition = {
                left: linkOffset.left,
                top: linkOffset.top + linkHeight + 5
            };

            var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

            var desiredWidth = Math.min($(window).width() * .8, 250);
            var desiredHeight = Math.min($(window).height() * .8, 300);

            var minWidth = 100;
            var minHeight = 100;

            this._selectionDialog = new Solovis.UI.Dialog({
                container: selectorControlHostDiv,
                ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

                title: false,
                autoOpen: true,
                destroyOnClose: true,
                actions: ["Close"],
                noAnimation: true,
                position: adjustedPosition,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,

                buttons: [
                    {
                        label: "Clear",
                        click: function () {
                            selectionCallback(null);
                            self._selectionDialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._selectionDialog.close();
                        }
                    }
                ],

                resize: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    selectorControl.setAvailableHeight(overallHeight);
                },

                activate: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    selectorControl.setAvailableHeight(overallHeight);
                },

                deactivate: function () {
                    self._selectionDialog = null;
                }
            });
        };
    }

}
